// axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://grandbazzar-back.onrender.com/'
});

export default axiosInstance;

export const weburl = 'https://grandbazzar-back.onrender.com/';
export const keyLogin = '6790rttec0545454d4a7a631';

